import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function PaymentConditionsIcon({ className }: IconProps) {
  return (
    <svg
      width="77"
      height="98"
      viewBox="0 0 77 98"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_2181)">
        <path
          d="M12.7422 21.3167C12.7422 33.0835 22.3636 42.6334 34.2186 42.6334C46.0735 42.6334 55.695 33.0835 55.695 21.3167C55.695 9.54988 46.0735 0 34.2186 0C22.3636 0 12.7422 9.54988 12.7422 21.3167Z"
          fill="#00416B"
        />
        <path
          d="M42.4373 26.376L47.0475 28.6497C44.8712 32.4299 40.9196 34.8742 35.9371 34.8742C29.7519 34.8742 25.1416 31.0941 23.5094 25.6938H19.0137L21.2759 22.0274H22.9367C22.9081 21.7716 22.9081 21.5442 22.9081 21.3168V20.7199H19.0423L21.3045 17.025H23.538C25.113 11.568 29.7519 7.73096 35.9657 7.73096C40.9196 7.73096 44.8712 10.1753 47.0762 13.9554L42.4659 16.2861C41.1487 14.1544 38.9438 12.8185 35.9657 12.8185C32.6727 12.8185 30.2387 14.4955 29.0074 17.0535H41.7214L39.4592 20.7484H28.1197V21.3452C28.1197 21.5726 28.1197 21.8284 28.1483 22.0558H39.1442L37.1111 25.7223H29.0933C30.3246 28.2518 32.7013 29.8435 35.9657 29.8435C38.9151 29.8435 41.1487 28.5076 42.4659 26.4044L42.4373 26.376Z"
          fill="white"
        />
        <path
          d="M68.4381 98.0001H6.84381C3.06396 98.0001 0 94.9589 0 91.2072V43.6567C0 39.905 3.06396 36.8638 6.84381 36.8638H68.4381C72.2179 36.8638 75.2819 39.905 75.2819 43.6567V91.2072C75.2819 94.9589 72.2179 98.0001 68.4381 98.0001Z"
          fill="#DFE2E9"
        />
        <path
          d="M61.5943 98.0001H6.84381C3.06396 98.0001 0 94.9589 0 91.2072V43.6567C0 39.905 3.06396 36.8638 6.84381 36.8638H61.5943C65.3741 36.8638 68.4381 39.905 68.4381 43.6567V91.2072C68.4381 94.9589 65.3741 98.0001 61.5943 98.0001Z"
          fill="#EAEDF8"
        />
        <path
          d="M75.2818 77.6213H54.7504C49.0807 77.6213 44.499 73.0738 44.499 67.4462C44.499 61.8186 49.0807 57.271 54.7504 57.271H75.2818C76.2268 57.271 77 58.0384 77 58.9763V75.9444C77 76.8824 76.2268 77.6498 75.2818 77.6498"
          fill="#B0B9CF"
        />
        <g style={{ mixBlendMode: 'multiply' }}>
          <mask
            id="mask0_1147_2181"
            style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="45"
            y="58"
            width="20"
            height="19"
          >
            <path
              d="M64.1424 58.0952H45.3291V76.7686H64.1424V58.0952Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_1147_2181)">
            <g mask="url(#mask1_1147_2181)">
              <mask
                id="mask2_1147_2181"
                maskUnits="userSpaceOnUse"
                x="45"
                y="58"
                width="20"
                height="19"
              >
                <path
                  d="M64.1424 58.0952H45.3291V76.7686H64.1424V58.0952Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask2_1147_2181)">
                <mask
                  id="mask3_1147_2181"
                  maskUnits="userSpaceOnUse"
                  x="45"
                  y="58"
                  width="20"
                  height="19"
                >
                  <path
                    d="M64.1424 58.0952H45.3291V76.7686H64.1424V58.0952Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask3_1147_2181)">
                  <rect
                    x="44.1553"
                    y="56.7593"
                    width="20.6173"
                    height="20.464"
                    fill="url(#pattern0)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <path
          d="M60.9069 67.4462C60.9069 70.8285 58.1579 73.557 54.7503 73.557C51.3427 73.557 48.5938 70.8285 48.5938 67.4462C48.5938 64.064 51.3427 61.3354 54.7503 61.3354C58.1579 61.3354 60.9069 64.064 60.9069 67.4462Z"
          fill="#FBFCFE"
        />
        <path
          d="M59.1894 67.446C59.1894 69.8903 57.1849 71.8514 54.751 71.8514C52.317 71.8514 50.3125 69.8619 50.3125 67.446C50.3125 65.0301 52.317 63.0405 54.751 63.0405C57.1849 63.0405 59.1894 65.0301 59.1894 67.446Z"
          fill="#00C4B3"
        />
        <path
          d="M35.9375 44.6797H32.5299C31.9572 44.6797 31.499 44.2249 31.499 43.6565C31.499 43.0881 31.9572 42.6333 32.5299 42.6333H35.9375C36.5102 42.6333 36.9683 43.0881 36.9683 43.6565C36.9683 44.2249 36.5102 44.6797 35.9375 44.6797Z"
          fill="#00416B"
        />
        <path
          d="M35.9375 92.2305H32.5299C31.9572 92.2305 31.499 91.7757 31.499 91.2073C31.499 90.6388 31.9572 90.1841 32.5299 90.1841H35.9375C36.5102 90.1841 36.9683 90.6388 36.9683 91.2073C36.9683 91.7757 36.5102 92.2305 35.9375 92.2305Z"
          fill="#00416B"
        />
        <path
          d="M27.7187 44.6797H24.3111C23.7384 44.6797 23.2803 44.2249 23.2803 43.6565C23.2803 43.0881 23.7384 42.6333 24.3111 42.6333H27.7187C28.2914 42.6333 28.7496 43.0881 28.7496 43.6565C28.7496 44.2249 28.2914 44.6797 27.7187 44.6797Z"
          fill="#00416B"
        />
        <path
          d="M27.7187 92.2305H24.3111C23.7384 92.2305 23.2803 91.7757 23.2803 91.2073C23.2803 90.6388 23.7384 90.1841 24.3111 90.1841H27.7187C28.2914 90.1841 28.7496 90.6388 28.7496 91.2073C28.7496 91.7757 28.2914 92.2305 27.7187 92.2305Z"
          fill="#00416B"
        />
        <path
          d="M19.501 44.6797H16.0934C15.5207 44.6797 15.0625 44.2249 15.0625 43.6565C15.0625 43.0881 15.5207 42.6333 16.0934 42.6333H19.501C20.0737 42.6333 20.5318 43.0881 20.5318 43.6565C20.5318 44.2249 20.0737 44.6797 19.501 44.6797Z"
          fill="#00416B"
        />
        <path
          d="M19.501 92.2305H16.0934C15.5207 92.2305 15.0625 91.7757 15.0625 91.2073C15.0625 90.6388 15.5207 90.1841 16.0934 90.1841H19.501C20.0737 90.1841 20.5318 90.6388 20.5318 91.2073C20.5318 91.7757 20.0737 92.2305 19.501 92.2305Z"
          fill="#00416B"
        />
        <path
          d="M11.2822 44.6797H7.87462C7.30191 44.6797 6.84375 44.2249 6.84375 43.6565C6.84375 43.0881 7.30191 42.6333 7.87462 42.6333H11.2822C11.8549 42.6333 12.3131 43.0881 12.3131 43.6565C12.3131 44.2249 11.8549 44.6797 11.2822 44.6797Z"
          fill="#00416B"
        />
        <path
          d="M11.2822 92.2305H7.87462C7.30191 92.2305 6.84375 91.7757 6.84375 91.2073C6.84375 90.6388 7.30191 90.1841 7.87462 90.1841H11.2822C11.8549 90.1841 12.3131 90.6388 12.3131 91.2073C12.3131 91.7757 11.8549 92.2305 11.2822 92.2305Z"
          fill="#00416B"
        />
        <path
          d="M60.9065 44.6797H57.4703C56.8976 44.6797 56.4395 44.2249 56.4395 43.6565C56.4395 43.0881 56.8976 42.6333 57.4703 42.6333H60.9065C61.4792 42.6333 61.9374 43.0881 61.9374 43.6565C61.9374 44.2249 61.4792 44.6797 60.9065 44.6797Z"
          fill="#00416B"
        />
        <path
          d="M60.9065 92.2305H57.4703C56.8976 92.2305 56.4395 91.7757 56.4395 91.2073C56.4395 90.6388 56.8976 90.1841 57.4703 90.1841H60.9065C61.4792 90.1841 61.9374 90.6388 61.9374 91.2073C61.9374 91.7757 61.4792 92.2305 60.9065 92.2305Z"
          fill="#00416B"
        />
        <path
          d="M52.6885 92.2305H49.2809C48.7082 92.2305 48.25 91.7757 48.25 91.2073C48.25 90.6388 48.7082 90.1841 49.2809 90.1841H52.6885C53.2612 90.1841 53.7193 90.6388 53.7193 91.2073C53.7193 91.7757 53.2612 92.2305 52.6885 92.2305Z"
          fill="#00416B"
        />
        <path
          d="M52.6885 44.6797H49.2809C48.7082 44.6797 48.25 44.2249 48.25 43.6565C48.25 43.0881 48.7082 42.6333 49.2809 42.6333H52.6885C53.2612 42.6333 53.7193 43.0881 53.7193 43.6565C53.7193 44.2249 53.2612 44.6797 52.6885 44.6797Z"
          fill="#00416B"
        />
        <path
          d="M44.47 44.6797H41.0338C40.4611 44.6797 40.0029 44.2249 40.0029 43.6565C40.0029 43.0881 40.4611 42.6333 41.0338 42.6333H44.47C45.0427 42.6333 45.5009 43.0881 45.5009 43.6565C45.5009 44.2249 45.0427 44.6797 44.47 44.6797Z"
          fill="#00416B"
        />
        <path
          d="M44.47 92.2305H41.0338C40.4611 92.2305 40.0029 91.7757 40.0029 91.2073C40.0029 90.6388 40.4611 90.1841 41.0338 90.1841H44.47C45.0427 90.1841 45.5009 90.6388 45.5009 91.2073C45.5009 91.7757 45.0427 92.2305 44.47 92.2305Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_1147_2181" transform="scale(0.0714286)" />
        </pattern>
        <clipPath id="clip0_1147_2181">
          <rect width="77" height="98" fill="white" />
        </clipPath>
        <image
          id="image0_1147_2181"
          width="14"
          height="14"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAABcRAAAXEQHKJvM/AAABaElEQVQokW2S227cMAxEDy+ybDcp+v9f2TTdXdsSqT7YXSyQzCOhQw5GI2OMwYvGgBwJCCIgIghf5U8AyBy0HuxHZzBQVYopU3FM5Ss4gIjkvje2vfFx28hMijvrXFhqYa0FN0PkBYxItqPz8fng87Hz2Bs9ElXhsRfWeUJ+rixVKK4nOIAeyed948994/ffjf1obEenuD2XuCkD4d0mVATPHNy2g+3o3PfG7brYIrCutB5MbtweB/NU6OFMbjgMMpMeydE6Rw+OHieYiSDs13xvnX4tUgaAkHmmaCqICCqCiaLXl6gIbopc6bjoOZiKUYtRijPnoPXz8VQua67U4rhd4QiwzoUep93IgYoQV6rva+Vtqfx6Wyhu2BMUwc1Y6wmPMVimwtECNeFtnvixVJZamCdH/1sFMBXm6iBQi7G3ICJQPe3N1anFn9cA5LWrOQatJxFJz8REMFNqsWco34KvRZfvmv2if/Zvy3BnPpbXAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
}
